import { bl_fi_incoming_einvoice_unmatched_history_RowClass } from '../../dbschema/bl_fi_incoming_einvoice_unmatched_history.model';
import { BaseContainerModel } from '../base-container.model';

export class IncomingEInvoiceUnMatchedHistoryContainerModel extends BaseContainerModel {
    bl_fi_incoming_einvoice_unmatched_history: bl_fi_incoming_einvoice_unmatched_history_RowClass = new bl_fi_incoming_einvoice_unmatched_history_RowClass();
}
